<template>
  <div v-if="scheduleDetails">
    <div class="section-title mb-3">{{ $t("editSchedule") }} </div>
    <div class="row mx-0 white-wrapper">
      <div class="col-md-3 mb-4 dropdown-curve-container">
        <div>
          <div class="d-flex justify-content-center align-items-center">
            <label :class="scheduleDetails.cine_name ? 'shift-up' : ''"
              >{{ $t("cinemas") }}</label
            >
            <b-dropdown
              :disabled="true"
              :text="scheduleDetails.cine_name"
              variant="dropdown-curve"
              class="w-100"
            >
              <div class="px-2 pb-2">
                <input
                  required
                  autofocus
                  type="search"
                  :placeholder="$tc('searchCinema')"
                  class="form-control form-control-sm"
                  v-on:keyup="onSearchCinema($event.target.value)"
                  v-on:keydown="onSearchCinema($event.target.value)"
                  v-model="searchCinema"
                />
              </div>
              <b-dropdown-item
                v-for="(Cinema, CinemaIndex) in CinemasList"
                :key="CinemaIndex"
                v-on:click="onSelectCinema($event, Cinema)"
                >{{ Cinema.cine_name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
      </div>

      <div class="col-md-3 mb-4">
        <!-- <div class>
          <label>{{ $tc("startdate", 1) }}</label>
        </div> -->
        <div class="d-flex align-items-center">
          <div class="input-material">
            <div class="add-datepicker">
              <button class="btn-clearDate" v-on:click="clear_ss_start_date()">
                ✖
              </button>
              <Datepicker :monday-first="true"
                ref="programaticOpen"
                v-model="scheduleDetails.ss_start_date"
                name="showstartdate"
                id="showstartdate"
                v-validate="'required'"
                :disabled-dates="disabledDates"
              />
              <!-- :disabledDates="{
                        to: new Date(Date.now() - 8640000)
                  }"-->
              <label :class="scheduleDetails.ss_start_date ? 'active' : ''"
                >{{ $t("show") }} {{ $t("start") }} {{ $t("date") }}</label
              >
            </div>
          </div>
          <!-- <Tooltip :title="$t('tooltip')" />-->
        </div>
        <p
          v-if="submitted && errors.has('showstartdate')"
          class="error_message"
        >
          {{ errors.first("showstartdate") }}
        </p>
      </div>

      <div class="col-lg-3">
        <div>
          <div class="input-material">
            <div class="add-datepicker">
              <Datepicker :monday-first="true"
                ref="programaticOpen"
                v-model="scheduleDetails.ss_end_date"
                name="showenddate"
                id="showenddate"
                v-validate="'required'"
              />
              <!-- :disabledDates="{ to: new Date(Date.now() - 8640000)}" -->
              <label :class="scheduleDetails.ss_start_date ? 'active' : ''"
                >{{ $t("end") }} {{ $t("date") }}</label
              >
            </div>
          </div>
          <!-- <Tooltip :title="$t('tooltip')" />-->
        </div>
        <p v-if="submitted && errors.has('showenddate')" class="error_message">
          {{ errors.first("showenddate") }}
        </p>
      </div>

      <!-- <div class="col-12 col-md-3 col-lg-3 mb-4 mb-lg-0">
        <div class>
          <label>Category </label>
        </div>
        <div class>
          <div class="dropdown-curve-container">
            <multiselect
              :options="CategoryList"
              :searchable="true"
              v-model="scheduleDetails.CategoryName"
              label="category_name"
              track-by="category_id"
              placeholder="Select Category"
              :allowEmpty="false"
              :showLabels="false"
            />
          </div>
          <p
            v-if="submitted && scheduleDetails.CategoryName.length == 0"
            class="error_message"
          >
            {{ msgcategory }}
          </p>
        </div>
      </div> -->

      <div class="col-md-3 col-lg-3 mb-4">
        <div class="d-flex align-items-center">
          <div class="input-material">
            <input
              style="text-align:right;"
              :placeholder="$t('inmins')"
              v-model="scheduleDetails.min_seats"
              type="text"
              name="MinSeats"
              id="MinSeats"
              v-validate="'required|numeric'"
              @blur="validateMinSeats($event, screenObj)"
            />
            <label :class="scheduleDetails.min_seats ? 'active' : ''"
              >Min Seats
              {{
                scheduleDetails.screen_total_seats
                  ? `(Total Seats: ${scheduleDetails.screen_total_seats})`
                  : ""
              }}
            </label>
          </div>
        </div>
        <p
          v-if="
            submitted &&
              errors.has('MinSeats') &&
              scheduleDetails.minSeats == ''
          "
          class="error_message"
        >
          Please enter minimum seats
        </p>
      </div>

      <div
        class="col-md-3 col-lg-3 mb-4 dropdown-curve-container"
        v-for="(prArray, prArrayIndex) in scheduleDetails.PrivateArray"
        :key="prArrayIndex"
      >
        <div class="d-flex justify-content-center align-items-center">
          <label :class="prArray.rc_g_name ? 'shift-up' : ''"
            >{{ $t("privateScreeningCharge") }}</label
          >
          <b-dropdown
            class="w-100"
            variant="dropdown-curve"
            :text="prArray.rc_g_name"
          >
            <div class="px-2 pb-2">
              <input
                required
                autofocus
                type="search"
                class="form-control form-control-sm"
                :placeholder="$t('searchRateCard')"
                v-on:keyup="onSearchPrivateRateCard($event, prArrayIndex)"
                v-on:keydown="onSearchPrivateRateCard($event, prArrayIndex)"
                v-model="prArray.searchRateCard"
              />
            </div>
            <b-dropdown-item
              v-for="(Ratecard, RatecardIndex) in PrivateRatecardsList"
              :key="RatecardIndex"
              v-on:click="onChangeRateCardScreenMulti(Ratecard, prArrayIndex)"
              >{{ Ratecard.rc_g_name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
        <p
          v-if="
            submitted &&
              screenObj.privateRateCard.rate_card_name ==
                'Select Rate Card Group'
          "
          class="error_message"
        >
          {{ msgratecard }}
        </p>
      </div>

      <div class="col-12 col-md-3 mb-4">
        <div class="d-flex align-items-center">
          <div class="input-material">
            <input
            style="text-align:right;"
              :placeholder="$t('inmins')"
              v-model="scheduleDetails.interval_time_in_mins"
              type="text"
              name="intervaltime"
              id="intervaltime1"
              v-validate="'required|numeric'"
            />
            <label
              :class="scheduleDetails.interval_time_in_mins ? 'active' : ''"
              >{{ $t("intervaltime") }}
            </label>
          </div>
        </div>
        <p
          v-if="
            submitted &&
              errors.has('intervaltime') &&
              moviesObj.interval_time_in_mins == ''
          "
          class="error_message"
        >
          {{ errors.first("intervaltime") }}
        </p>
      </div>

      <div class="col-12 col-md-3 mb-4 md-lg-0">
        <div class="d-flex align-items-center">
          <div class="input-material">
            <input
            style="text-align:right;"
              :placeholder="$t('inmins')"
              v-model="scheduleDetails.cleaning_time_in_mins"
              type="text"
              name="cleaningtime"
              id="cleaningtime1"
              v-validate="'required|numeric'"
            />
            <label
              :class="scheduleDetails.cleaning_time_in_mins ? 'active' : ''"
              >{{ $t("cleaningtime") }}
            </label>
          </div>
        </div>
        <p
          v-if="
            submitted &&
              errors.has('cleaningtime') &&
              moviesObj.cleaning_time_in_mins == ''
          "
          class="error_message"
        >
          {{ errors.first("cleaningtime") }}
        </p>
      </div>

      <div class="col-12 col-md-3 col-lg-3 mb-4 md-lg-0">
        <div class="d-flex align-items-center">
          <div class="input-material">
            <input
            style="text-align:right;"
              :placeholder="$t('inmins')"
              v-model="scheduleDetails.ads_time_in_mins"
              type="text"
              name="settingadstime"
              id="settingadstime1"
              v-validate="'required|numeric'"
            />
            <label :class="scheduleDetails.ads_time_in_mins ? 'active' : ''"
              >{{ $t("advertisementtime") }}
            </label>
          </div>
        </div>
        <p
          v-if="
            submitted &&
              errors.has('settingadstime') &&
              moviesObj.cleaning_time_in_mins == ''
          "
          class="error_message"
        >
          {{ errors.first("settingadstime") }}
        </p>
      </div>

      <div class="row mx-0">
        <div class="col-12 col-md-3 col-lg-3 mb-4 mb-lg-0">
          <div class="custom-timepicker label-timepicker">
            <div class="input-material">
              <label
                :class="
                  scheduleDetails.start_time_range ? 'shift-up' : 'shift-up'
                "
                >{{ $t("start") }} {{ $t("time") }} {{ $t("range") }}
              </label>
              <vue-timepicker
                manual-input
                v-model="scheduleDetails.start_time_range"
                id="showtime"
                name="showtime"
                format="HH:mm"
                placeholder="HH:mm"
                class="time_picker"
                input-width="100%"
                auto-scroll
                lazy
                v-validate="'required'"
                @change="
                  onChangeShowStartTime(
                    $event,
                    screenMainIndex,
                    moviesIndex,
                    showTimeIndex
                  )
                "
              ></vue-timepicker>
              <!-- <date-picker
                          v-model="showTimeObj.start_time"
                          @change="
                            onChangeShowStartTime(
                              $event,
                              screenMainIndex,
                              moviesIndex,
                              showTimeIndex
                            )
                          "
                          lang="en"
                          type="time"
                          :disabled-time="true"
                          format="hh:mm a"
                          :minute-step="1"
                          class="time_picker"
                          placeholder="Show Time"
                          @input="onclose($event)"
                          name="showtime"
                          id="showtime"
                          v-validate="'required'"
                        ></date-picker> -->
              <!-- v-model="selectedMoviesInScreens[selectedScreenIndex].movies[selectedMovieIndex].ss_start_show_time" -->
            </div>
            <p
              v-if="
                submitted &&
                  errors.has('showtime') &&
                  showTimeObj.start_time == ''
              "
              class="error_msg"
            >
              Please enter start time
            </p>
          </div>
        </div>
        <div class="col-12 col-md-3 col-lg-3 mb-4 mb-lg-0">
          <div class="custom-timepicker label-timepicker">
            <div class="input-material">
              <label
                :class="
                  scheduleDetails.end_time_range ? 'shift-up' : 'shift-up'
                "
                >{{ $t("start") }} {{ $t("end") }} {{ $t("range") }}
              </label>
              <vue-timepicker
                manual-input
                v-model="scheduleDetails.end_time_range"
                id="endtime"
                name="endtime"
                format="HH:mm"
                class="time_picker"
                input-width="100%"
                auto-scroll
                lazy
                v-validate="'required'"
                @change="
                  onChangeShowEndTime(
                    $event,
                    screenMainIndex,
                    moviesIndex,
                    showTimeIndex
                  )
                "
              ></vue-timepicker>
              <!-- <date-picker
                          v-model="showTimeObj.start_time"
                          @change="
                            onChangeShowStartTime(
                              $event,
                              screenMainIndex,
                              moviesIndex,
                              showTimeIndex
                            )
                          "
                          lang="en"
                          type="time"
                          :disabled-time="true"
                          format="hh:mm a"
                          :minute-step="1"
                          class="time_picker"
                          placeholder="Show Time"
                          @input="onclose($event)"
                          name="showtime"
                          id="showtime"
                          v-validate="'required'"
                        ></date-picker> -->
              <!-- v-model="selectedMoviesInScreens[selectedScreenIndex].movies[selectedMovieIndex].ss_start_show_time" -->
            </div>
            <p
              v-if="
                submitted && errors.has('endtime') && showTimeObj.end_time == ''
              "
              class="error_msg"
            >
              {{ errors.first("endtime") }}
            </p>
          </div>
        </div>
        <div class="col-12 col-md-3 col-lg-3 mb-4 mb-lg-0">
          <div class="custom-timepicker label-timepicker">
            <div class="input-material">
              <label
                :class="scheduleDetails.interval_time_range ? 'shift-up' : ''"
                >{{ $t("intervalMin") }}
              </label>
                 <div class="d-flex align-items-center">
                    <div class="input-material">
                        <input
                        style="text-align:right;"
                        :placeholder="$t('intervalMin')"
                        v-model="scheduleDetails.interval_time_range"
                         type="number"
                        name="cleaningtime"
                        id="cleaningtime1"
                        v-validate="'required|numeric'"
                         />
                    </div>
                  </div>
              <!-- <vue-timepicker
                :minute-interval="5"
                format="mm"
                name="intervalTIme"
                id="intervalTIme"
                manual-input
                class="time_picker"
                v-validate="'required'"
                v-model="scheduleDetails.interval_time_range"
              >
              </vue-timepicker> -->
              <!-- <date-picker
                          v-model="showTimeObj.start_time"
                          @change="
                            onChangeShowStartTime(
                              $event,
                              screenMainIndex,
                              moviesIndex,
                              showTimeIndex
                            )
                          "
                          lang="en"
                          type="time"
                          :disabled-time="true"
                          format="hh:mm a"
                          :minute-step="1"
                          class="time_picker"
                          placeholder="Show Time"
                          @input="onclose($event)"
                          name="showtime"
                          id="showtime"
                          v-validate="'required'"
                        ></date-picker> -->
              <!-- v-model="selectedMoviesInScreens[selectedScreenIndex].movies[selectedMovieIndex].ss_start_show_time" -->
            </div>
            <p
              v-if="
                submitted &&
                  errors.has('intervalTIme') &&
                  showTimeObj.interval_time_min == ''
              "
              class="error_msg"
            >
              Please Enter Interval Time
            </p>
          </div>
        </div>

        <div
          class="col-4 my-3 d-flex justify-content-start align-items-center"
          v-for="(item, index_s) in ShowTypeArray"
          :key="index_s"
        >
          <input
            type="checkbox"
            class="ios-checkbox"
            @click="saveShowType(item, screenMainIndex)"
            v-model="item.value"
            style="height: 20px; width: 20px; margin-right: 5px"
          />
          <span class="switch-slider"> {{ item.screening_name }}</span>
        </div>

        <div class="col-12 my-2">
          <div class="row mx-0">
            <b-form-checkbox
              v-for="(weekdaysLoop, weekdaysKey) in weekDays"
              :key="weekdaysKey"
              style="min-width: 125px"
              class="j-checkbox mb-3"
              @change="
                onChangeWeekdays(
                  $event,
                  weekdaysKey,
                  screenseatIndex,
                  singleRatecardIndex
                )
              "
              v-model="weekDays[weekdaysKey]"
            >
              <div class="text-capitalize">
                {{ weekdaysKey }}
              </div>
            </b-form-checkbox>
          </div>
        </div>
      </div>

      <div class="row mx-0">
        <div
          class="col-12 col-md-6 col-lg-6 mb-lg-0 mb-5 dropdown-curve-container"
          :key="SeatTypesIndex"
          v-for="(SeatTypes, SeatTypesIndex) in scheduleDetails.PricingArray"
        >
          <div class="d-flex justify-content-center align-items-center">
            <label :class="SeatTypes.rc_g_name ? 'shift-up' : ''">{{
              SeatTypes.sst_seat_type
            }}</label>
            <b-dropdown
              class="w-100"
              variant="dropdown-curve"
              :text="SeatTypes.rc_g_name"
            >
              <div class="px-2 pb-2">
                <input
                  required
                  autofocus
                  type="search"
                  class="form-control form-control-sm"
                  :placeholder="$tc('searchRateCard')"
                  v-on:keyup="
                    onSearchRateCardMulti(
                      $event,
                      screenMainIndex,
                      moviesIndex,
                      showTimeIndex,
                      SeatTypesIndex
                    )
                  "
                  v-on:keydown="
                    onSearchRateCardMulti(
                      $event,
                      screenMainIndex,
                      moviesIndex,
                      showTimeIndex,
                      SeatTypesIndex
                    )
                  "
                  v-model="SeatTypes.searchRateCard"
                />
              </div>
              <b-dropdown-item
                v-for="(Ratecard, RatecardIndex) in RatecardsList"
                :key="RatecardIndex"
                v-on:click="onChangeRateCardMulti(Ratecard, SeatTypesIndex)"
                >{{ Ratecard.rc_g_name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
          <p
            v-if="
              submitted && SeatTypes.rate_card_name == 'Select Rate Card Group'
            "
            class="error_message"
          >
            {{ msgratecard }}
          </p>
        </div>
      </div>

      <div class="col-lg-12 text-center pt-4 pb-3">
        <button @click.prevent.stop="onSubmit('INSERT', 16)" class="btn-blue">
          {{ $t("submit") }}
        </button>

        <!-- <button @click.prevent.stop="onUpdate()" class="btn-blue">{{ $t('save') }}</button>-->
      </div>
    </div>
  </div>
</template>

<script>
import momentT from "moment-timezone";

import scheduleService from "@/services/scheduleService";
import MyCinemaService from "@/services/MyCinemaService";
import CinemasService from "@/services/CinemasService";
import MasterService from "@/services/MasterService";
import moment from "moment";
import { BASEURL } from "@/config/index.js";
import Vue from "vue";
import DatePicker from "vue2-datepicker";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

export default {
  components: { DatePicker, VueTimepicker },
  data() {
    return {
      scheduleDetails: {
        PrivateArray: [{ rateCard: { searchRateCard: "", rc_g_name: "ajit" } }]
      },
      disabledDates: {
        to: new Date(Date.now() - 8640000)
      },
      CategoryList: [],
      RatecardsList: [],
      RatecardsListCopy: [],
      ShowTypeArray: [],
      weekDays: {
        selectAll: true,
        sunday: true,
        monday: true,
        tuesday: true,
        wednesday: true,
        thursday: true,
        friday: true,
        saturday: true
      },
      PrivateRatecardsList: [],
      PrivateRatecardsListCopy: []
    };
  },
  beforeMount() {
    // this.getGoGoCategory();

    this.getScheduleDetails();
  },
  methods: {
    async onSubmit() {
      const weekdayPayload = {
        is_sunday: this.weekDays.sunday === true ? "Y" : "N",
        is_monday: this.weekDays.monday === true ? "Y" : "N",
        is_tuesday: this.weekDays.tuesday === true ? "Y" : "N",
        is_wednesday: this.weekDays.wednesday === true ? "Y" : "N",
        is_thursday: this.weekDays.thursday === true ? "Y" : "N",
        is_friday: this.weekDays.friday === true ? "Y" : "N",
        is_saturday: this.weekDays.saturday === true ? "Y" : "N"
      };
      const showTypePayload = {
        is_confirmed_show: this.ShowTypeArray[0].value === true ? "Y" : "N",
        is_crowd_show: this.ShowTypeArray[1].value === true ? "Y" : "N",
        is_private_show: this.ShowTypeArray[2].value === true ? "Y" : "N"
      };
      const RateCardArray = [
        ...this.scheduleDetails.PricingArray,
        ...this.scheduleDetails.PrivateArray
      ];
      const payload = {
        ...this.scheduleDetails,
        ...weekdayPayload,
        ...showTypePayload,
        RateCardArray
      };
      console.log("payload :>> ", payload);
      const { data } = await MyCinemaService.UpdateSchedule(payload);
      if (data && data.status) {
        this.$router.push(`/my-cinema/schedule-list`);
      }
    },
    onChangeRateCardMulti(ratecard, index) {
      let myVariable = this.scheduleDetails.PricingArray[index];
      console.log(
        "🚀 ~ file: editSchedule.vue ~ line 662 ~ onChangeRateCardMulti ~ ratecard",
        ratecard
      );
      console.log(
        "🚀 ~ file: editSchedule.vue ~ line 670 ~ onChangeRateCardScreenMulti ~ this.scheduleDetails.PrivateArray[index]",
        this.scheduleDetails.PricingArray[index]
      );
      myVariable.rate_card_group_id = ratecard.rc_g_id;
      myVariable.rc_g_name = ratecard.rc_g_name;
      myVariable.rate_card_id = ratecard.rc_id;

      // rcg name, rc_private_id,
    },
    onChangeRateCardScreenMulti(ratecard, index) {
      let myVariable = this.scheduleDetails.PrivateArray[index];
      console.log(
        "🚀 ~ file: editSchedule.vue ~ line 668 ~ onChangeRateCardScreenMulti ~ ratecard",
        ratecard
      );
      console.log(
        "🚀 ~ file: editSchedule.vue ~ line 670 ~ onChangeRateCardScreenMulti ~ this.scheduleDetails.PrivateArray[index]",
        this.scheduleDetails.PrivateArray[index]
      );
      myVariable.rate_card_group_id = ratecard.rc_g_id;
      myVariable.rc_g_name = ratecard.rc_g_name;
      myVariable.rate_card_id = ratecard.rc_id;
      myVariable.rate_card_private_id = ratecard.rc_g_id;
      // rcg name, rc_private_id,
    },
    onSearchRateCardScreenMulti: function(event, screenIndex) {
      this.scheduleDetails.PrivateArray[screenIndex]["searchRateCard"] =
        event.target.value;
      let searchVal = this.scheduleDetails.PrivateArray[screenIndex][
        "searchRateCard"
      ];
      if (searchVal.length > 0) {
        this.RatecardsList = this.RatecardsListCopy.filter(x => {
          if (x.rc_g_name.toLowerCase().includes(searchVal.toLowerCase()))
            return x;
        });
      } else {
        this.RatecardsList = this.RatecardsListCopy;
      }
      this.$forceUpdate();
    },
    onSearchPrivateRateCard: function(event, screenIndex) {
      this.scheduleDetails.PrivateArray[screenIndex]["searchRateCard"] =
        event.target.value;
      let searchVal = this.scheduleDetails.PrivateArray[screenIndex][
        "searchRateCard"
      ];
      if (searchVal.length > 0) {
        this.PrivateRatecardsList = this.PrivateRatecardsListCopy.filter(x => {
          if (x.rc_g_name.toLowerCase().includes(searchVal.toLowerCase()))
            return x;
        });
      } else {
        this.PrivateRatecardsList = this.PrivateRatecardsListCopy;
      }
      this.$forceUpdate();
    },
    async getScheduleDetails() {
      console.log(this.$route.query);
      const { scheduleId } = this.$route.query;
      const { data } = await MyCinemaService.GetScheduleDetails({ scheduleId });
      console.log("data :>> ", data);
      if (data && data.status) {
        this.scheduleDetails = data.Records[0];
        this.scheduleDetails.interval_time_range =
          String(this.scheduleDetails.interval_time_range).length == 1
            ? `0${this.scheduleDetails.interval_time_range}`
            : String(this.scheduleDetails.interval_time_range);
        // this.scheduleDetails.CategoryName = this.CategoryList.find(
        //   cat => cat.category_id === this.scheduleDetails.ss_category_id
        // );
        this.getRatecardsList(this.scheduleDetails.cinema_id);
        this.ShowTypeArray = [
          {
            booking_type_id: "1",
            screening_name: "Confirmed Screening",
            value: this.scheduleDetails.is_confirmed_show === "Y"
          },
          {
            booking_type_id: "2",
            screening_name: "CrowdSource Screening",
            value: this.scheduleDetails.is_crowd_show === "Y"
          },
          {
            booking_type_id: "3",
            screening_name: "Private Screening",
            value: this.scheduleDetails.is_private_show === "Y"
          }
        ];
        this.weekDays = {
          selectAll:
            this.scheduleDetails.is_sunday === "Y" &&
            this.scheduleDetails.is_monday === "Y" &&
            this.scheduleDetails.is_tuesday === "Y" &&
            this.scheduleDetails.is_wednesday === "Y" &&
            this.scheduleDetails.is_thursday === "Y" &&
            this.scheduleDetails.is_friday === "Y" &&
            this.scheduleDetails.is_saturday === "Y",
          sunday: this.scheduleDetails.is_sunday === "Y",
          monday: this.scheduleDetails.is_monday === "Y",
          tuesday: this.scheduleDetails.is_tuesday === "Y",
          wednesday: this.scheduleDetails.is_wednesday === "Y",
          thursday: this.scheduleDetails.is_thursday === "Y",
          friday: this.scheduleDetails.is_friday === "Y",
          saturday: this.scheduleDetails.is_saturday === "Y"
        };
      }
    },
    getRatecardsList: function(cinema_id) {
      console.log(`cinema_id`, cinema_id);
      scheduleService
        .GetPrivateRatecardGroupByCinemaId({ cinema_id })
        .then(response => {
          const { data } = response;
          if (data && data.Records.length > 0) {
            this.RatecardsList = data.Records.filter(
              x => x.is_private_rate_card == "N"
            );
            this.RatecardsListCopy = data.Records.filter(
              x => x.is_private_rate_card == "N"
            );
            this.PrivateRatecardsList = data.Records.filter(
              x => x.is_private_rate_card == "Y"
            );
            this.PrivateRatecardsListCopy = data.Records.filter(
              x => x.is_private_rate_card == "Y"
            );

            console.log(`this.scheduleDetails1.`, this.scheduleDetails);
            // let manav = this.RatecardsList.filter(rc => {
            //   console.log("rc :>> ", rc);
            //   return (
            //     rc.rc_g_id ===
            //     this.scheduleDetails.PrivateArray[0].rate_card_group_id
            //   );
            // });
            console.log("manav :>> ", manav);
            // this.scheduleDetails.PrivateArray[0]["rateCard"] = manav[0];
            console.log(`this.scheduleDetails.2`, this.scheduleDetails);
          } else {
            this.RatecardsList = [];
            this.RatecardsListCopy = [];
            this.PrivateRatecardsList = [];
            this.PrivateRatecardsListCopy = [];

            // Show Message Here:
            this.$toasted.show("No Rate Cards Found for selected cinema");
            this.$refs["test"].hide();
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch Error on getCinemaSetting :", error);
        });
    },
    getGoGoCategory() {
      this.CategoryList = [];
      MyCinemaService.getCategoryList()
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // this.lists.screens = data.Records;
            this.CategoryList = data.Records;
            console.log(this.CategoryList);
          } else {
            // Show Message Here:
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          this.$toasted.show(Error(error));
          console.log("Catch Error on getCategoryList :", error);
        });
    },
    validateMinSeats($event, screenObj) {
      let selectedMinSeats = $event.target.value;
      if (parseInt(selectedMinSeats) && parseInt(selectedMinSeats) > 0) {
        let totalSeats = this.scheduleDetails.screen_total_seats;
        if (parseInt(selectedMinSeats) > totalSeats) {
          this.$toasted.show(
            "Minimum seats cannot be greater than total seats"
          );
          this.scheduleDetails.minSeats = "";
        }
      } else {
        this.$toasted.show("Enter a valid number");
        this.scheduleDetails.minSeats = "";
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/MyCinemaComponents/MultiScheduling/editSchedule.vue